import { Drawer as DrawerBase } from 'antd';
import styled from 'styled-components';

export const StyledDrawer = styled(DrawerBase)`
  .ant-drawer-body {
    padding: 0;
  }

  .ant-drawer-header {
    background: #008080;
    padding: 8px 16px;
  }

  .ant-drawer-header-title {
    .ant-drawer-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #ffffff;
      font-size: 20px;
      font-weight: 400;

      svg {
        font-size: 16px;
      }
    }

    .ant-drawer-close {
      display: none;
    }
  }
`;
